'use strict'

const crypto = require('crypto')
const https = require('https')

export default class Utils {

    static hashString(algo, value, output) {
        return new Promise((resolve, reject) => {
            try {
                output = output || 'hex'
                resolve(crypto.createHash(algo).update(value).digest('hex'))
            } catch (error) {
                reject(error)
            }
        })
    }

    static randomRassword (len) {
        len = len || Utils.Config.RANDOM_PASS_MAX_LEN
        const possible = 'abcdefghijklmnopqrstuwxyzABCDEFGHIJKLMNOPQRSTUWXYZ0123456789._!'
        let pass = ''
        for (let i = 0; i < len; i++) {
            pass += possible.charAt(Math.floor(Math.random() * possible.length))
        }
        return pass
    }
    
    static hashPassword (password) {
        return new Promise((resolve, reject) => {
            let config = Utils.Config.Hash
            crypto.randomBytes(config.saltBytes, function(err, salt) {
                if (err) {
                    return reject(err)
                }
        
                salt = salt.toString(config.encoding)
                crypto.pbkdf2(password, salt, config.iterations, config.hashBytes, config.algo, function(err, hash) {
                    if (err) {
                        return reject(err)
                    }
        
                    return resolve({ hash: hash.toString(config.encoding), salt: salt })
                })
            })
        })
    }
    
    static verifyPassword (password, hash, salt) {
        return new Promise((resolve, reject) => {
            let config = Utils.Config.Hash
            crypto.pbkdf2(password, salt, config.iterations, config.hashBytes, config.algo, function(err, verify) {
                verify = verify.toString(config.encoding)
                if (verify === hash) {
                    resolve()
                } else {
                    reject('Verification failed')
                }
            })
        })
    }
    
    static verifyPasswords (passwords, pwdToCheck) {
        return new Promise((resolve, reject) => {
            if(passwords.length <= 0) {
                return reject('No match')
            }
    
            let pwd = passwords[0]
            passwords.splice(0, 1)
    
            if(!pwd.hash || !pwd.salt) {
                return Utils.verifyPasswords(passwords, pwdToCheck)
                    .then((result) => {
                        return resolve(result)
                    }).catch((err) => {
                        return reject(err)
                    })
            }
    
            Utils.verifyPassword(pwdToCheck, pwd.hash, pwd.salt, (err, pass) => {
                if(err) {
                    return Utils.verifyPasswords(passwords, pwdToCheck)
                    .then((result) => {
                        return resolve(result)
                    }).catch((err) => {
                        return reject(err)
                    })
                } else {
                    return resolve({ index: passwords.length, pwd: pwd })
                }
            })
        })
    }
    
    static isArray (checkVar) {
       return(Object.prototype.toString.call(checkVar) === 
                    '[object Array]')
    }

    static isNumber (val) {
        return val !== null && val !== undefined && (typeof val === 'number' || !isNaN(val))
    }
    
    static getFBUserFriends (url, feedCallback) {
        return new Promise((resolve, reject) => {
            // 'QVFIUlEwM3NTRWNrdnlQOGxGcWxhRUJ1VmJsajYzWHlUUWJRZAF9rUXRra2RCRkdWWmtyd1JiWk0tYzlfNHRyZAUlQVzZAzRzFub1JSNS1kVlB4d3M3eGFrZAFJ3'
            https.get(url, (res) => {
                const statusCode = res && res.statusCode
                
                // let error
                if (statusCode !== 200) {
                    console.error('Request Failed.\n' +
                    `Status Code: ${statusCode}`)
                    // consume response data to free up memory
                    res.resume()
                    return reject(res)
                }
                
                res.setEncoding('utf8')
                let rawData = ''
                res.on('data', (chunk) => { rawData += chunk })
                res.on('end', () => {
                    try {
                        let json = JSON.parse(rawData)
                        feedCallback(json)
                        if(json.paging && json.paging.next) {
                            return Utils.getFBUserFriends(json.paging.next, feedCallback)
                            .then(() => {
                                return resolve()
                            }).catch((e) => {
                                return reject(e)
                            })
                        }
                        return resolve()                    
                    } catch (e) {
                        console.error(e.message)
                        return reject(e)
                    }
                })
            }).on('error', (e) => {
                console.error(`Got error: ${e.message}`)
                return reject(e)
            })
        })
    }

    static BufferFrom (str, encode) {
        encode = encode || 'binary'
        
        try {
            return Buffer.from(str, encode) // Ta-da
        } catch(e) {
            return new Buffer(str, encode) // Ta-da
        }
    }
}

Utils.Config = {
    RANDOM_PASS_MAX_LEN: 8,
    Hash: {
        // larger numbers mean better security, less
        // size of the generated hash
        hashBytes: 32,
        // larger salt means hashed passwords are more resistant to rainbow table, but
        // you get diminishing returns pretty fast
        saltBytes: 16,
        // more iterations means an attacker has to take longer to brute force an
        // individual password, so larger is better. however, larger also means longer
        // to hash the password. tune so that hashing the password takes about a
        // second
        iterations: 1000,
        algo       :'sha512',
        encoding   : 'hex'     // hex is readable but base64 is shorter
    }
}



// WEBPACK FOOTER //
// ./src/common/utils.js